/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuremovelunchtitle3Inputs */

const en_menuremovelunchtitle3 = /** @type {(inputs: Menuremovelunchtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the lunch menu?`)
};

const de_menuremovelunchtitle3 = /** @type {(inputs: Menuremovelunchtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü entfernen?`)
};

/**
* | output |
* | --- |
* | "Remove the lunch menu?" |
*
* @param {Menuremovelunchtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuremovelunchtitle3 = /** @type {((inputs?: Menuremovelunchtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuremovelunchtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuremovelunchtitle3(inputs)
	return de_menuremovelunchtitle3(inputs)
});
export { menuremovelunchtitle3 as "menuRemoveLunchTitle" }